export default __webpack_public_path__ + "static/media/1166.ed7a6340.png";